<div class="h-full flex flex-col relative">
  
  <!-- Scrollable content -->
  <div class="flex-1 overflow-y-auto scrollable-content">
  
  <!-- Header (tylko mobile - tytuł i close button) -->
  <div *ngIf="isMobile" class="flex items-center justify-between mb-4">
    <span class="text-lg font-semibold text-gray-900 dark:text-white">Filtry</span>
    <button mat-icon-button (click)="closePanel.emit()">
      <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
    </button>
  </div>
  
  <!-- Search -->
   <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Szukaj</h3>
  <mat-form-field class="w-full" subscriptSizing="dynamic" data-tour-id="szukaj-dokumenty">
    <mat-icon matPrefix [svgIcon]="'tabler_outline:search'" class="mr-2 text-gray-400"></mat-icon>
    <input 
      matInput 
      [value]="searchValue"
      (input)="onSearchInput($event)"
      placeholder="Numer, kontrahent, NIP...">
    <button 
      *ngIf="searchValue" 
      mat-icon-button 
      matSuffix 
      (click)="clearSearch()">
      <mat-icon [svgIcon]="'tabler_outline:x'" class="icon-size-4"></mat-icon>
    </button>
  </mat-form-field>
  
  <!-- View tabs (pionowe) -->
  <div class="mt-6" data-tour-id="widok-dokumenty">
    <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Widok</h3>
    
    <div class="space-y-1">
      <button 
        *ngFor="let tab of viewTabs"
        (click)="setView(tab.id)"
        class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left transition-all duration-200"
        [class.bg-primary]="filters.view === tab.id"
        [class.text-white]="filters.view === tab.id"
        [class.shadow-sm]="filters.view === tab.id"
        [class.hover:bg-gray-100]="filters.view !== tab.id"
        [class.dark:hover:bg-gray-800]="filters.view !== tab.id">
        <mat-icon 
          class="icon-size-5" 
          [class.text-white]="filters.view === tab.id"
          [svgIcon]="tab.icon">
        </mat-icon>
        <span class="flex-1 font-medium">{{ tab.label }}</span>
        <span 
          class="text-xs px-2 py-0.5 rounded-full font-medium"
          [class.bg-white]="filters.view === tab.id"
          [class.bg-opacity-20]="filters.view === tab.id"
          [class.text-white]="filters.view === tab.id"
          [class.bg-gray-200]="filters.view !== tab.id"
          [class.dark:bg-gray-700]="filters.view !== tab.id">
          {{ getStatForView(tab.id) }}
        </span>
      </button>
    </div>
  </div>
  
  <!-- Zakres dat (przeniesiony nad źródło) -->
  <div class="mt-6">
    <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">Zakres dat</h3>
    
    <!-- Predefiniowane zakresy -->
    <div class="flex flex-wrap gap-1 mb-3">
      <button 
        type="button"
        (click)="setDatePreset('today')"
        class="text-xs px-2 py-1 rounded-md border transition-colors"
        [ngClass]="activePreset === 'today' 
          ? 'border-primary bg-primary/10 text-primary' 
          : 'border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'">
        Dzisiaj
      </button>
      <button 
        type="button"
        (click)="setDatePreset('last7days')"
        class="text-xs px-2 py-1 rounded-md border transition-colors"
        [ngClass]="activePreset === 'last7days' 
          ? 'border-primary bg-primary/10 text-primary' 
          : 'border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'">
        Ostatnie 7 dni
      </button>
      <button 
        type="button"
        (click)="setDatePreset('thisMonth')"
        class="text-xs px-2 py-1 rounded-md border transition-colors"
        [ngClass]="activePreset === 'thisMonth' 
          ? 'border-primary bg-primary/10 text-primary' 
          : 'border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'">
        Ten miesiąc
      </button>
      <button 
        type="button"
        (click)="setDatePreset('last30days')"
        class="text-xs px-2 py-1 rounded-md border transition-colors"
        [ngClass]="activePreset === 'last30days' 
          ? 'border-primary bg-primary/10 text-primary' 
          : 'border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'">
        Ostatnie 30 dni
      </button>
      <button 
        type="button"
        (click)="setDatePreset('lastMonth')"
        class="text-xs px-2 py-1 rounded-md border transition-colors"
        [ngClass]="activePreset === 'lastMonth' 
          ? 'border-primary bg-primary/10 text-primary' 
          : 'border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700'">
        Poprzedni miesiąc
      </button>
    </div>
    
    <div class="flex items-end gap-2">
      <!-- Od -->
      <div class="flex-1">
        <label class="text-xs text-gray-500 dark:text-gray-400 mb-1 block">Od</label>
        <div class="relative">
          <input 
            type="text"
            readonly
            class="date-input w-full pl-2 pr-6 py-1.5 text-sm text-center border rounded-md cursor-pointer focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
            [class.bg-transparent]="!filters.dateFrom"
            [class.border-gray-300]="!filters.dateFrom"
            [class.dark:border-gray-600]="!filters.dateFrom"
            [class.bg-white]="filters.dateFrom"
            [class.dark:bg-gray-700]="filters.dateFrom"
            [class.border-primary]="filters.dateFrom"
            [value]="dateFromDisplay"
            placeholder="—"
            (click)="pickerFrom.open()">
          <button 
            *ngIf="filters.dateFrom"
            type="button"
            class="absolute right-1 top-1/2 -translate-y-1/2 p-0.5 rounded hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
            (click)="clearDateFrom(); $event.stopPropagation()">
            <mat-icon class="icon-size-3.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300" [svgIcon]="'tabler_outline:x'"></mat-icon>
          </button>
          <input 
            matInput 
            [matDatepicker]="pickerFrom"
            [value]="dateFromValue"
            (dateChange)="onDateFromChange($event.value)"
            class="date-input-hidden">
          <mat-datepicker #pickerFrom></mat-datepicker>
        </div>
      </div>
      
      <span class="text-gray-400 text-sm pb-1.5">–</span>
      
      <!-- Do -->
      <div class="flex-1">
        <label class="text-xs text-gray-500 dark:text-gray-400 mb-1 block">Do</label>
        <div class="relative">
          <input 
            type="text"
            readonly
            class="date-input w-full pl-2 pr-6 py-1.5 text-sm text-center border rounded-md cursor-pointer focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
            [class.bg-transparent]="!filters.dateTo"
            [class.border-gray-300]="!filters.dateTo"
            [class.dark:border-gray-600]="!filters.dateTo"
            [class.bg-white]="filters.dateTo"
            [class.dark:bg-gray-700]="filters.dateTo"
            [class.border-primary]="filters.dateTo"
            [value]="dateToDisplay"
            placeholder="—"
            (click)="pickerTo.open()">
          <button 
            *ngIf="filters.dateTo"
            type="button"
            class="absolute right-1 top-1/2 -translate-y-1/2 p-0.5 rounded hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
            (click)="clearDateTo(); $event.stopPropagation()">
            <mat-icon class="icon-size-3.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300" [svgIcon]="'tabler_outline:x'"></mat-icon>
          </button>
          <input 
            matInput 
            [matDatepicker]="pickerTo"
            [value]="dateToValue"
            (dateChange)="onDateToChange($event.value)"
            class="date-input-hidden">
          <mat-datepicker #pickerTo></mat-datepicker>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Źródło dokumentu -->
  <div class="mt-6">
    <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3 flex items-center gap-1">
      Źródło
      <mat-icon 
        class="icon-size-3.5 text-gray-400 cursor-help" 
        [svgIcon]="'tabler_outline:help-circle'"
        matTooltip="Lokalne - dokumenty utworzone w tym programie. KSeF - dokumenty pobrane z Krajowego Systemu e-Faktur.">
      </mat-icon>
    </h3>
    
    <div class="flex flex-wrap gap-2">
      <button 
        *ngFor="let source of sources"
        (click)="setSource(source.id)"
        class="px-3 py-1.5 text-sm rounded-full border transition-all duration-200"
        [class.bg-primary]="filters.source === source.id"
        [class.text-white]="filters.source === source.id"
        [class.border-primary]="filters.source === source.id"
        [class.border-gray-300]="filters.source !== source.id"
        [class.dark:border-gray-600]="filters.source !== source.id"
        [class.hover:border-gray-400]="filters.source !== source.id">
        {{ source.label }}
      </button>
    </div>
  </div>
  
  <!-- Status KSeF (zwijany) -->
  <div class="mt-6">
    <button 
      type="button"
      (click)="toggleSection('ksefStatus')"
      class="w-full flex items-center justify-between group cursor-pointer mb-3">
      <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider">Status KSeF</h3>
      <mat-icon 
        class="icon-size-4 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-transform duration-200"
        [class.rotate-180]="!isSectionCollapsed('ksefStatus')"
        [svgIcon]="'tabler_outline:chevron-down'">
      </mat-icon>
    </button>
    
    <div [hidden]="isSectionCollapsed('ksefStatus')" class="space-y-1">
      <button 
        *ngFor="let status of ksefStatuses"
        (click)="setKsefStatus(status.id)"
        class="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left text-sm transition-all duration-200 border"
        [class.border-primary]="filters.ksefStatus === status.id"
        [class.text-primary]="filters.ksefStatus === status.id"
        [class.border-transparent]="filters.ksefStatus !== status.id"
        [class.hover:bg-gray-50]="filters.ksefStatus !== status.id"
        [class.dark:hover:bg-gray-800]="filters.ksefStatus !== status.id">
        <mat-icon class="icon-size-4" [class]="status.color" [svgIcon]="status.icon"></mat-icon>
        <span class="flex-1">{{ status.label }}</span>
        <span *ngIf="status.id === 'pending' && stats.pendingKsef > 0" 
              class="text-xs text-orange-500 font-semibold">
          {{ stats.pendingKsef }}
        </span>
      </button>
    </div>
  </div>
  
  <!-- Status płatności (zwijany) -->
  <div class="mt-6">
    <button 
      type="button"
      (click)="toggleSection('paymentStatus')"
      class="w-full flex items-center justify-between group cursor-pointer mb-3">
      <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider">Status płatności</h3>
      <mat-icon 
        class="icon-size-4 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-transform duration-200"
        [class.rotate-180]="!isSectionCollapsed('paymentStatus')"
        [svgIcon]="'tabler_outline:chevron-down'">
      </mat-icon>
    </button>
    
    <div [hidden]="isSectionCollapsed('paymentStatus')" class="space-y-1">
      <button 
        *ngFor="let status of paymentStatuses"
        (click)="setPaymentStatus(status.id)"
        class="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left text-sm transition-all duration-200 border"
        [class.border-primary]="filters.paymentStatus === status.id"
        [class.text-primary]="filters.paymentStatus === status.id"
        [class.border-transparent]="filters.paymentStatus !== status.id"
        [class.hover:bg-gray-50]="filters.paymentStatus !== status.id"
        [class.dark:hover:bg-gray-800]="filters.paymentStatus !== status.id">
        <mat-icon class="icon-size-4" [class]="status.color" [svgIcon]="status.icon"></mat-icon>
        <span class="flex-1">{{ status.label }}</span>
        <span *ngIf="status.id === 'overdue' && stats.overdue > 0" 
              class="text-xs text-red-500 font-semibold">
          {{ stats.overdue }}
        </span>
      </button>
    </div>
  </div>
  
  <!-- Metoda płatności (zwijana) -->
  <div class="mt-6">
    <button 
      type="button"
      (click)="toggleSection('paymentMethods')"
      class="w-full flex items-center justify-between group cursor-pointer mb-3">
      <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider">
        Metoda płatności
        <span *ngIf="filters.paymentMethods?.length" class="ml-1 text-primary font-normal">
          ({{ filters.paymentMethods.length }})
        </span>
      </h3>
      <mat-icon 
        class="icon-size-4 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-transform duration-200"
        [class.rotate-180]="!isSectionCollapsed('paymentMethods')"
        [svgIcon]="'tabler_outline:chevron-down'">
      </mat-icon>
    </button>
    
    <div [hidden]="isSectionCollapsed('paymentMethods')" class="space-y-1">
      <button 
        *ngFor="let method of paymentMethodOptions"
        (click)="togglePaymentMethod(method.ksefValue)"
        class="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left text-sm transition-all duration-200 border"
        [ngClass]="isPaymentMethodSelected(method.ksefValue) 
          ? 'border-primary bg-primary/5 text-primary' 
          : 'border-transparent hover:bg-gray-50 dark:hover:bg-gray-800'">
        <mat-icon 
          class="icon-size-4" 
          [class.text-primary]="isPaymentMethodSelected(method.ksefValue)"
          [svgIcon]="method.icon">
        </mat-icon>
        <span class="flex-1">{{ method.label }}</span>
        <div 
          class="w-4 h-4 rounded border-2 flex items-center justify-center transition-colors"
          [ngClass]="isPaymentMethodSelected(method.ksefValue) 
            ? 'border-primary bg-primary' 
            : 'border-gray-300 dark:border-gray-500'">
          <mat-icon 
            *ngIf="isPaymentMethodSelected(method.ksefValue)" 
            class="icon-size-3 text-white" 
            [svgIcon]="'tabler_outline:check'">
          </mat-icon>
        </div>
      </button>
    </div>
  </div>
  
  <!-- Typy dokumentów (zwijane) -->
  <div class="mt-6">
    <button 
      type="button"
      (click)="toggleSection('documentTypes')"
      class="w-full flex items-center justify-between group cursor-pointer mb-3">
      <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider">
        Typ dokumentu
        <span *ngIf="filters.documentTypes?.length" class="ml-1 text-primary font-normal">
          ({{ filters.documentTypes.length }})
        </span>
      </h3>
      <mat-icon 
        class="icon-size-4 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-transform duration-200"
        [class.rotate-180]="!isSectionCollapsed('documentTypes')"
        [svgIcon]="'tabler_outline:chevron-down'">
      </mat-icon>
    </button>
    
    <div [hidden]="isSectionCollapsed('documentTypes')" class="space-y-1">
      <button 
        *ngFor="let type of documentTypes"
        (click)="toggleDocumentType(type.id)"
        class="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left text-sm transition-all duration-200 border"
        [ngClass]="isDocumentTypeSelected(type.id) 
          ? 'border-primary bg-primary/5 text-primary' 
          : 'border-transparent hover:bg-gray-50 dark:hover:bg-gray-800'">
        <div 
          class="w-4 h-4 rounded border-2 flex items-center justify-center transition-colors"
          [ngClass]="isDocumentTypeSelected(type.id) 
            ? 'border-primary bg-primary' 
            : 'border-gray-300 dark:border-gray-500'">
          <mat-icon 
            *ngIf="isDocumentTypeSelected(type.id)" 
            class="icon-size-3 text-white" 
            [svgIcon]="'tabler_outline:check'">
          </mat-icon>
        </div>
        <span class="flex-1">{{ type.label }}</span>
      </button>
    </div>
  </div>
  
  <!-- Adnotacje (zwijane) -->
  <div class="mt-6">
    <button 
      type="button"
      (click)="toggleSection('annotations')"
      class="w-full flex items-center justify-between group cursor-pointer mb-3">
      <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider flex items-center gap-1">
        Adnotacje
        <span *ngIf="filters.annotations?.length" class="ml-1 text-primary font-normal">
          ({{ filters.annotations.length }})
        </span>
        <mat-icon 
          class="icon-size-3.5 text-gray-400 cursor-help" 
          [svgIcon]="'tabler_outline:help-circle'"
          matTooltip="Filtruj faktury po adnotacjach KSeF - samofakturowanie, MPP, odwrotne obciążenie i inne.">
        </mat-icon>
      </h3>
      <mat-icon 
        class="icon-size-4 text-gray-400 group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-transform duration-200"
        [class.rotate-180]="!isSectionCollapsed('annotations')"
        [svgIcon]="'tabler_outline:chevron-down'">
      </mat-icon>
    </button>
    
    <div [hidden]="isSectionCollapsed('annotations')" class="space-y-1">
      <button 
        *ngFor="let annotation of annotationFilters"
        (click)="toggleAnnotation(annotation.id)"
        class="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left text-sm transition-all duration-200 border"
        [ngClass]="isAnnotationSelected(annotation.id) 
          ? 'border-primary bg-primary/5 text-primary' 
          : 'border-transparent hover:bg-gray-50 dark:hover:bg-gray-800'">
        <mat-icon 
          class="icon-size-4" 
          [class]="isAnnotationSelected(annotation.id) ? 'text-primary' : annotation.color"
          [svgIcon]="annotation.icon">
        </mat-icon>
        <span class="flex-1">{{ annotation.label }}</span>
        <div 
          class="w-4 h-4 rounded border-2 flex items-center justify-center transition-colors"
          [ngClass]="isAnnotationSelected(annotation.id) 
            ? 'border-primary bg-primary' 
            : 'border-gray-300 dark:border-gray-500'">
          <mat-icon 
            *ngIf="isAnnotationSelected(annotation.id)" 
            class="icon-size-3 text-white" 
            [svgIcon]="'tabler_outline:check'">
          </mat-icon>
        </div>
      </button>
    </div>
  </div>
  
  <!-- Spacer na dole dla przycisku -->
  <div class="min-h-20"></div>
  
  <!-- Clear filters button - sticky na dole, zawsze widoczny -->
  <div 
    *ngIf="hasActiveFilters"
    class="sticky clear-filters-container py-4 flex justify-center bg-gradient-to-t from-card via-card to-transparent z-20"
    style="position: sticky !important;"
    >
    <button 
      mat-flat-button
      class="!rounded-full shadow-xl !bg-gradient-to-r !from-red-500 !to-rose-600 !text-white hover:!from-red-600 hover:!to-rose-700 !px-5 !py-1"
      (click)="clearFilters()">
      <mat-icon [svgIcon]="'tabler_outline:filter-off'" class="mr-2 !text-white"></mat-icon>
      <span class="font-medium">Wyczyść filtry</span>
      <span class="ml-2 bg-white/20 px-2 py-0.5 rounded-full text-xs">{{ activeFiltersCount }}</span>
    </button>
  </div>
  
  </div><!-- koniec scrollable content -->
  
</div>
